// extracted by mini-css-extract-plugin
module.exports = {"title":"offerList_title__1RWEG","container":"offerList_container__29kXP"};